import { SVGProps } from "react";
import { Icon } from "@chakra-ui/react";
import { TIconComponent } from "./icon-component.types";

const COMMON_SVG_PROPS: SVGProps<SVGPathElement & SVGRectElement & SVGPolylineElement> = {
    fill: "none",
    stroke: "#333",
    strokeWidth: "15.3px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
};

export const MagnifyingGlassWikifolio: TIconComponent = props => (
    <Icon viewBox="0 0 664.89 609.35" {...props}>
        <g id="icons">
            <g>
                <path
                    {...COMMON_SVG_PROPS}
                    d="M157.59,403.61c-32.34-35.71-52.05-83.09-52.05-135.07,0-111.16,90.1-201.28,201.26-201.28,27.52,0,53.75,5.52,77.65,15.52"
                />
                <path {...COMMON_SVG_PROPS} d="M210.57,445.35c-9.53-5.2-18.59-11.14-27.11-17.76" />
                <path
                    {...COMMON_SVG_PROPS}
                    d="M489.1,183.09c12.18,25.94,18.98,54.9,18.98,85.45,0,111.16-90.12,201.28-201.28,201.28-24.95,0-48.83-4.54-70.88-12.84"
                />
                <path
                    {...COMMON_SVG_PROPS}
                    d="M608.43,170.9l7.47,20.74c3.45,9.59,11.01,17.15,20.6,20.6l20.74,7.47-20.74,7.47c-9.59,3.45-17.15,11.01-20.6,20.6l-7.47,20.74-7.47-20.74c-3.45-9.59-11.01-17.15-20.6-20.6l-20.74-7.47,20.74-7.47c9.59-3.45,17.15-11.01,20.6-20.6l7.47-20.74Z"
                />
                <path
                    {...COMMON_SVG_PROPS}
                    d="M67.25,7.65l9.12,25.33c4.22,11.71,13.44,20.94,25.16,25.16l25.33,9.12-25.33,9.12c-11.71,4.22-20.94,13.44-25.16,25.16l-9.12,25.33-9.12-25.33c-4.22-11.71-13.44-20.94-25.16-25.16l-25.33-9.12,25.33-9.12c11.71-4.22,20.94-13.44,25.16-25.16l9.12-25.33Z"
                />
                <path
                    {...COMMON_SVG_PROPS}
                    d="M141.77,460.56l7.47,20.74c3.45,9.59,11.01,17.15,20.6,20.6l20.74,7.47-20.74,7.47c-9.59,3.45-17.15,11.01-20.6,20.6l-7.47,20.74-7.47-20.74c-3.45-9.59-11.01-17.15-20.6-20.6l-20.74-7.47,20.74-7.47c9.59-3.45,17.15-11.01,20.6-20.6l7.47-20.74Z"
                />
                <rect x="428.23" y="428.5" width="89.28" height="46.52" transform="translate(457.94 -202.05) rotate(45)" {...COMMON_SVG_PROPS} />
                <polyline
                    {...COMMON_SVG_PROPS}
                    fill="#95c11f"
                    points="472.09 143.09 486.83 82.79 418.25 82.79 372.25 298.43 336.67 163.02 273.45 163.02 237.86 298.43 222.18 226.27 153.04 226.27 198.48 375.77 274.66 375.77 305.05 255.41 335.45 375.77 415.21 375.77 455.24 212"
                />
                <path
                    {...COMMON_SVG_PROPS}
                    fill="#d5e6a5"
                    d="M500.83,414.41l108.79,108.8c18.76,18.74,18.01,49.61-2.24,67.4-18.48,16.23-46.79,14.18-64.18-3.22l-109.48-109.48,67.11-63.51Z"
                />
            </g>
        </g>
    </Icon>
);
